export default __webpack_public_path__ + "static/media/logo-dsf-e-white-blue.52097831.svg";